// Constantes de roles — fuente única de verdad
export const ROLES = {
  ADMIN: "ROLE_ADMIN",
  USER: "ROLE_USER",
  SUPER_ADMIN: "ROLE_SUPER_ADMIN",
  GUEST: "ROLE_GUEST",
};
